import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  focusTarget() {
    const target = this.#getFocusTarget()
    if (!target) return

    // For whatever reason, calling .focus() does not work unless it is placed
    // in a setTimeout. This also allows the target to (mostly) animate into
    // its focus state on scroll end (not always since native smooth scroll
    // time varies but 1s seems to be the best compromise)
    setTimeout(() => {
      target.focus({ preventScroll: true, focusVisible: true })
    }, 1000)
  }

  #getFocusTarget() {
    const scrollTarget = document.querySelector(
      this.element.getAttribute('href')
    )

    if (!scrollTarget) return null

    const childTargets = scrollTarget.querySelectorAll(
      '[data-scroll-focus-target]'
    )

    let focusTarget

    if (!childTargets.length) {
      focusTarget = scrollTarget
    } else if (childTargets.length === 1) {
      focusTarget = childTargets[0]
    } else {
      focusTarget = Array.from(childTargets).filter(child => {
        return getComputedStyle(child).display !== 'none'
      })[0]
    }

    return focusTarget
  }
}
